export default __webpack_public_path__ + "0fd83835ad64a363377f911c1a780503.jpg";